import { render } from "./topParts.vue?vue&type=template&id=7133ee72&scoped=true"
import script from "./topParts.vue?vue&type=script&lang=js"
export * from "./topParts.vue?vue&type=script&lang=js"

import "./topParts.vue?vue&type=style&index=0&id=7133ee72&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7133ee72"]])

export default __exports__